import { handlerDesactivarFiltro, echartLineLinia } from './common';

export function echartUsuarisPerLinea(vis, datos) {
  echartLineLinia(
    'chartUsuarisPerLinea',
    'no_dataUsuarisPerLinea',
    datos.resultset,
    "ÚS D'EMT: USUARIS PER LÍNIA",
    false,
  );
}

export function usdEmtUsuarisPerLinea() {
  handlerDesactivarFiltro();
  $('#idAllFilterFields').show();
  $('#idFieldsFilterEmtUsLinea').show();
  $('#idFieldsFilterEmtUsTitol').hide();
}
